import React from 'react';
import ReactDOM from 'react-dom';
const { Icon, Card, Button } = window;
/* ============================================================
   BOOKER — Tela: Contratos originais (pasta local via API)
   Lista os arquivos .pdf/.docx servidos pelo backend e permite
   abrir cada um.
   ============================================================ */
var { useState, useEffect, useMemo } = React;

const fmtTamanho = (b) => {
  if (b == null) return '—';
  if (b < 1024) return b + ' B';
  if (b < 1024 * 1024) return (b / 1024).toFixed(0) + ' KB';
  return (b / 1024 / 1024).toFixed(1) + ' MB';
};
const fmtData = (iso) => { try { return new Date(iso).toLocaleDateString('pt-BR'); } catch { return '—'; } };

function Arquivos() {
  const [estado, setEstado] = useState('carregando'); // carregando | ok | erro
  const [dados, setDados] = useState({ pasta: '', arquivos: [] });
  const [erro, setErro] = useState('');
  const [busca, setBusca] = useState('');
  const [abrindo, setAbrindo] = useState('');
  const [importando, setImportando] = useState(false);
  const [confirmar, setConfirmar] = useState(null); // arquivo a excluir
  const [excluindo, setExcluindo] = useState(false);
  const [sincronizando, setSincronizando] = useState(false);
  const [pastaUrl, setPastaUrl] = useState('');
  const podeEditar = window.podeEditar ? window.podeEditar() : true;
  const [aditivos, setAditivos] = useState(null);   // candidatos a aditivo pós-upload
  const [vinculandoAd, setVinculandoAd] = useState(false);
  const fileRef = React.useRef(null);

  async function carregar() {
    setEstado('carregando'); setErro('');
    try {
      const d = await window.Api.apiContracts();
      setDados(d); setEstado('ok');
      window.Api.apiSharepointPendentes('contratos').then(sp => setPastaUrl((sp && sp.pastaUrl) || '')).catch(() => {});
    } catch (e) {
      setErro(e.message || 'Falha ao carregar'); setEstado('erro');
    }
  }
  useEffect(() => { carregar(); }, []);

  async function sincronizar() {
    setSincronizando(true);
    try {
      const r = await window.Api.apiSharepointSincronizar('contratos');
      if (r && r.ok) window.avisar(`Sincronizado! ${r.ligados} ligado(s), ${r.religados} religado(s)` + (r.novos ? `, ${r.novos} novo(s) a revisar (veja em Monitoramento)` : '') + '.');
      else window.avisar((r && r.erro) || 'Falha ao sincronizar.');
      carregar();
    } catch (e) { window.avisar(e.message); }
    finally { setSincronizando(false); }
  }

  const lista = useMemo(() => {
    const q = busca.trim().toLowerCase();
    const arr = dados.arquivos || [];
    return q ? arr.filter(a => a.nome.toLowerCase().includes(q)) : arr;
  }, [dados, busca]);

  async function abrir(nome) {
    setAbrindo(nome);
    try { await window.Api.abrirArquivo(nome); }
    catch (e) { setErro(e.message); }
    finally { setAbrindo(''); }
  }

  async function excluir() {
    if (!confirmar) return;
    setExcluindo(true);
    try {
      const r = await window.Api.apiExcluirContrato(confirmar.nome);
      setConfirmar(null);
      window.avisar(`Contrato excluído permanentemente.` + (r.empresasDesvinculadas ? `\n${r.empresasDesvinculadas} empresa(s) desvinculada(s).` : ''));
      carregar();
      if (window.recarregarContratos) window.recarregarContratos();
    } catch (e) { window.avisar(e.message || 'Falha ao excluir.'); }
    finally { setExcluindo(false); }
  }

  async function importar(ev) {
    const files = [...(ev.target.files || [])].filter(f => f.name.toLowerCase().endsWith('.pdf'));
    if (ev.target) ev.target.value = '';
    if (!files.length) { window.avisar('Selecione arquivos PDF.'); return; }
    setImportando(true);
    try {
      const r = await window.Api.apiUpload(files);
      const rev = r.resultados.filter(x => x.ok && x.revisar).length;
      const falhas = r.resultados.filter(x => !x.ok);
      window.avisar(`Importado: ${r.ok} de ${r.total}.` + (rev ? ` ${rev} sem valor (a revisar).` : '') + (falhas.length ? `\nFalhas: ${falhas.map(f => f.arquivo + ' (' + f.erro + ')').join('; ')}` : ''));
      carregar();
      if (window.recarregarContratos) window.recarregarContratos();
      // aditivos importados que casam com um contrato-base existente (por CNPJ)
      const cands = r.resultados.filter(x => x.ok && x.tipoDoc === 'aditivo' && x.aditivoId && x.possivelAditivoDe);
      if (cands.length) setAditivos(cands.map(x => ({ nome: x.arquivo, aditivoId: x.aditivoId, base: x.possivelAditivoDe, vincular: true })));
    } catch (e) { window.avisar(e.message || 'Falha no upload.'); }
    finally { setImportando(false); }
  }

  function toggleAd(i) { setAditivos(a => a.map((x, j) => j === i ? { ...x, vincular: !x.vincular } : x)); }
  async function confirmarAditivos() {
    const sel = (aditivos || []).filter(x => x.vincular);
    setVinculandoAd(true);
    try {
      for (const x of sel) await window.Api.apiAditivoVincular(x.aditivoId, x.base.dbId);
      setAditivos(null);
      if (sel.length) {
        // oferece aplicar o rateio do aditivo ao contrato-base (nova vigência, preserva histórico)
        if (await window.confirmar(`${sel.length} aditivo(s) vinculado(s) ao contrato-base.\n\nAplicar agora o rateio do(s) aditivo(s) ao contrato-base? Isso cria uma nova vigência e preserva o histórico.`)) {
          const resumo = [];
          for (const x of sel) {
            try { const r = await window.Api.apiAditivoAplicar(x.aditivoId); resumo.push(`✓ ${x.nome}: novo total R$ ${r.total} desde ${r.vigencia}`); }
            catch (e) { resumo.push(`✗ ${x.nome}: ${e.message}`); }
          }
          window.avisar('Resultado:\n' + resumo.join('\n'));
        }
        carregar();
        if (window.recarregarContratos) window.recarregarContratos();
      }
    } catch (e) { window.avisar(e.message || 'Falha ao vincular.'); }
    finally { setVinculandoAd(false); }
  }

  return (
    <div style={{ animation: 'fadeUp .4s ease both' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 16, marginBottom: 22 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: 'var(--text-strong)', letterSpacing: '-.02em' }}>Contratos</h1>
          <p style={{ margin: '5px 0 0', color: 'var(--text-muted)', fontSize: 14 }}>
            Espelho da pasta de contratos no SharePoint · {estado === 'ok' ? `${dados.arquivos.length} arquivo(s)` : '…'}
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {podeEditar
            ? <Button variant="accent" size="md" icon="refresh" onClick={sincronizar}>{sincronizando ? 'Sincronizando…' : 'Sincronizar SharePoint'}</Button>
            : <Button variant="default" size="md" icon="refresh" onClick={carregar}>Atualizar</Button>}
        </div>
      </div>

      {/* Fonte dos contratos (SharePoint) */}
      {estado === 'ok' && (
        <Card pad={14} style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 11, flexWrap: 'wrap' }}>
          <span style={{ width: 36, height: 36, borderRadius: 9, background: 'var(--ok-bg)', color: 'var(--ok)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name="link" size={18} />
          </span>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600 }}>Fonte dos contratos</div>
            <div style={{ fontSize: 13, color: 'var(--text-strong)', fontWeight: 700 }}>SharePoint · DOCUMENTOS BOOKER <span style={{ color: 'var(--text-muted)', fontWeight: 500 }}>(o banco fica como reserva)</span></div>
          </div>
          {pastaUrl && (
            <a href={pastaUrl} target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 700, color: 'var(--booker-orange)', textDecoration: 'none' }}>
              <Icon name="external" size={14} /> Abrir a pasta no SharePoint
            </a>
          )}
        </Card>
      )}

      {/* Busca */}
      {estado === 'ok' && dados.arquivos.length > 0 && (
        <div style={{ position: 'relative', maxWidth: 420, marginBottom: 16 }}>
          <Icon name="search" size={17} style={{ position: 'absolute', left: 13, top: 11, color: 'var(--text-muted)' }} />
          <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por nome do contrato…"
            style={{ width: '100%', padding: '10px 12px 10px 40px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, outline: 'none' }} />
        </div>
      )}

      {/* Estados */}
      {estado === 'carregando' && (
        <Card pad={40} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
          <span style={{ width: 34, height: 34, border: '4px solid var(--surface-inset)', borderTopColor: 'var(--booker-orange)', borderRadius: 99, display: 'inline-block', animation: 'spin .8s linear infinite' }} />
          <div style={{ marginTop: 14, fontSize: 14 }}>Carregando contratos da pasta…</div>
        </Card>
      )}

      {estado === 'erro' && (
        <Card pad={28} style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <span style={{ width: 44, height: 44, borderRadius: 12, background: 'var(--danger-bg)', color: 'var(--danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="alert" size={22} /></span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-strong)' }}>Não foi possível carregar os contratos</div>
            <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 3 }}>{erro}</div>
            <div style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 6 }}>Verifique se o backend (API) está rodando em <span className="mono">{window.Api?.API_BASE}</span>.</div>
          </div>
          <Button variant="default" onClick={carregar}>Tentar de novo</Button>
        </Card>
      )}

      {estado === 'ok' && dados.arquivos.length === 0 && (
        <Card pad={40} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
          <Icon name="folder" size={32} style={{ color: 'var(--text-faint)' }} />
          <div style={{ marginTop: 12, fontSize: 14 }}>Nenhum contrato (.pdf/.docx) encontrado na pasta.</div>
        </Card>
      )}

      {/* Lista */}
      {estado === 'ok' && lista.length > 0 && (
        <Card pad={0}>
          {lista.map((a, i) => (
            <div key={a.nome} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '13px 18px', borderTop: i ? '1px solid var(--border)' : 'none' }}>
              <span style={{ width: 40, height: 40, borderRadius: 9, background: a.ext === 'pdf' ? 'var(--danger-bg)' : 'var(--info-bg)', color: a.ext === 'pdf' ? 'var(--danger)' : 'var(--info)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 10.5, flexShrink: 0 }}>{a.ext.toUpperCase()}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.nome}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{fmtTamanho(a.tamanho)} · modificado {fmtData(a.modificadoEm)}</div>
              </div>
              <Button size="sm" variant="default" icon="external" onClick={() => abrir(a.nome)}>
                {abrindo === a.nome ? 'Abrindo…' : 'Abrir'}
              </Button>
              {podeEditar && <button onClick={() => setConfirmar(a)} title="Excluir contrato permanentemente"
                style={{ width: 34, height: 34, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'var(--danger-bg)'; e.currentTarget.style.borderColor = 'var(--danger)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'var(--surface)'; e.currentTarget.style.borderColor = 'var(--border)'; }}>
                <Icon name="trash" size={16} />
              </button>}
            </div>
          ))}
          {busca && <div style={{ padding: '10px 18px', fontSize: 12, color: 'var(--text-muted)', borderTop: '1px solid var(--border)' }}>{lista.length} de {dados.arquivos.length} contratos</div>}
        </Card>
      )}

      {estado === 'ok' && lista.length === 0 && dados.arquivos.length > 0 && (
        <Card pad={28} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Nenhum contrato corresponde a “{busca}”.</Card>
      )}

      {/* Detecção de aditivos pós-importação */}
      {aditivos && aditivos.length > 0 && ReactDOM.createPortal(
        <div onClick={vinculandoAd ? undefined : () => setAditivos(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 120, animation: 'fadeIn .2s ease both', padding: '40px 20px', overflowY: 'auto' }}>
          <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 560, maxHeight: '88vh', overflowY: 'auto', background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both' }}>
            <div style={{ padding: '20px 22px', borderBottom: '1px solid var(--border)', display: 'flex', gap: 13, alignItems: 'center' }}>
              <span style={{ width: 44, height: 44, borderRadius: 12, background: 'var(--info-bg)', color: 'var(--info)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="link" size={22} /></span>
              <div>
                <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>Possível aditivo detectado</h3>
                <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--text-muted)' }}>Estes documentos têm o mesmo CNPJ de um contrato já existente. Vincular como aditivo do contrato-base?</p>
              </div>
            </div>
            <div style={{ padding: '8px 22px' }}>
              {aditivos.map((x, i) => (
                <label key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: i < aditivos.length - 1 ? '1px solid var(--border)' : 'none', cursor: 'pointer' }}>
                  <input type="checkbox" checked={x.vincular} onChange={() => toggleAd(i)} style={{ width: 17, height: 17, accentColor: 'var(--booker-orange)', flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{x.nome}</div>
                    <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>→ aditivo de <b style={{ color: 'var(--text)' }}>{x.base.codigo || x.base.razao || x.base.arquivo}</b></div>
                  </div>
                </label>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 10, padding: '12px 22px 20px' }}>
              <Button variant="default" onClick={vinculandoAd ? undefined : () => setAditivos(null)} style={{ flex: 1, justifyContent: 'center' }}>Manter como novos</Button>
              <Button variant="accent" icon={vinculandoAd ? undefined : 'link'} onClick={vinculandoAd ? undefined : confirmarAditivos} style={{ flex: 1.4, justifyContent: 'center' }}>{vinculandoAd ? 'Vinculando…' : 'Vincular selecionados'}</Button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* Confirmação de exclusão permanente */}
      {confirmar && ReactDOM.createPortal(
        <div onClick={excluindo ? undefined : () => setConfirmar(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 120, animation: 'fadeIn .2s ease both', padding: '40px 20px', overflowY: 'auto' }}>
          <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 460, background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both', overflow: 'hidden' }}>
            <div style={{ padding: '22px 22px 0', display: 'flex', gap: 14 }}>
              <span style={{ width: 46, height: 46, borderRadius: 12, background: 'var(--danger-bg)', color: 'var(--danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="alert" size={24} /></span>
              <div>
                <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>Excluir contrato permanentemente?</h3>
                <p style={{ margin: '6px 0 0', fontSize: 13.5, color: 'var(--text-muted)', lineHeight: 1.5 }}>
                  Esta ação <b style={{ color: 'var(--danger)' }}>não pode ser desfeita</b>. Serão removidos o PDF, os dados extraídos e o rateio deste contrato, e as empresas vinculadas serão desvinculadas.
                </p>
              </div>
            </div>
            <div style={{ margin: '16px 22px', padding: '11px 13px', background: 'var(--surface-inset)', borderRadius: 'var(--r-sm)', fontSize: 12.5, color: 'var(--text-strong)', fontWeight: 600, wordBreak: 'break-all', display: 'flex', alignItems: 'center', gap: 9 }}>
              <Icon name="folder" size={15} style={{ color: 'var(--danger)', flexShrink: 0 }} /> {confirmar.nome}
            </div>
            <div style={{ display: 'flex', gap: 10, padding: '0 22px 22px' }}>
              <Button variant="default" onClick={excluindo ? undefined : () => setConfirmar(null)} style={{ flex: 1, justifyContent: 'center' }}>Cancelar</Button>
              <Button variant="danger" icon={excluindo ? undefined : 'trash'} onClick={excluindo ? undefined : excluir} style={{ flex: 1.4, justifyContent: 'center', background: 'var(--danger)', color: '#fff', borderColor: 'var(--danger)' }}>{excluindo ? 'Excluindo…' : 'Excluir permanentemente'}</Button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}


Object.assign(window, { Arquivos });
